import { useContext } from "react";
import { blockListContext } from "../contexts/blockListContext";

export const useBlockList = () => {
  const { blockList, domainAllowList, isAllowGuest, isLoading } = useContext(blockListContext);
  return { blockList, domainAllowList, isAllowGuest, isLoading };
};
